import axios from 'axios';

export const baseURL = '/api/rest/s1/';
export const baseWebSocketURL = 'api/iamws';

export const Api = axios.create({
	baseURL: baseURL
});
